import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'config/hooks';
import {
    doAddJobToManifest,
    doUpdateManifestExternalReferences,
    doArchiveManifest,
    doCreateManifest,
    doGetManifestById,
    doUnarchiveManifest,
    doUpdateManifest,
} from 'store/manifests/actions';
import {
    UpdateManifestExternalReferencesPayload,
    AddRemoveJobFromManifestPayload,
    CreateManifestPayload,
    UpdateManifestPayload,
} from 'store/manifests/types';

const useManifests = () => {
    const manifest = useAppSelector((state) => state.manifests.manifest);
    const isLoading = useAppSelector((state) => state.manifests.isLoading);
    const error = useAppSelector((state) => state.manifests.error);

    const dispatch = useAppDispatch();

    const getManifestById = useCallback((manifestId: string) => dispatch(doGetManifestById(manifestId)), [dispatch]);

    const updateManifest = useCallback(
        (manifestId: string, payload: UpdateManifestPayload) => dispatch(doUpdateManifest(manifestId, payload)),
        [dispatch]
    );

    const archiveManifest = useCallback((manifestId: string) => dispatch(doArchiveManifest(manifestId)), [dispatch]);

    const createManifest = useCallback(
        (payload: CreateManifestPayload) => dispatch(doCreateManifest(payload)),
        [dispatch]
    );

    const unarchiveManifest = useCallback(
        (manifestId: string) => dispatch(doUnarchiveManifest(manifestId)),
        [dispatch]
    );

    const addJobToManifest = useCallback(
        (payload: AddRemoveJobFromManifestPayload) => dispatch(doAddJobToManifest(payload)),
        [dispatch]
    );

    const updateManifestExternalReferences = useCallback(
        (manifestId: string, payload: UpdateManifestExternalReferencesPayload) =>
            dispatch(doUpdateManifestExternalReferences(manifestId, payload)),
        [dispatch]
    );

    return {
        manifest,
        isLoading,
        error,
        getManifestById,
        updateManifest,
        archiveManifest,
        unarchiveManifest,
        createManifest,
        addJobToManifest,
        updateManifestExternalReferences,
    };
};

export default useManifests;
